import React from 'react';
import { TbFileExport } from 'react-icons/tb';

import { Icon, IconButton } from '../../../core-ui';

type Props = {
  isLoading: boolean;
  onClick: React.ComponentProps<typeof IconButton>['onClick'];
};

export function ExportSalesButton(props: Props) {
  const { isLoading, onClick } = props;
  return (
    <IconButton
      aria-label="Export"
      icon={<Icon as={TbFileExport} fontSize={20} />}
      isLoading={isLoading}
      onClick={onClick}
    />
  );
}
